import type { ReportDocument } from '@/lib/report-document'

/** CSS metin değişmezi: ters bölü, tırnak ve satır sonu kaçırılır. */
function cssString(value: string): string {
  const escaped = value.replace(/[\\"]/g, '\\$&').replace(/\r?\n/g, ' ')
  return `"${escaped}"`
}

/**
 * `@page` kuralı çalışma anında üretilir (docs/REPORT-DOCUMENTS-PLAN.md §7.3): boyut tanımın
 * yönünden gelir; üst bilgi metni margin kutusunda `var()` güvenilir olmadığı için doğrudan
 * yazılır. Kural yalnız baskı sayfası bağlıyken geçerlidir, uygulamanın diğer ekranlarını etkilemez.
 */
export function buildPageStyle({
  orientation,
  header,
  pageWord,
}: {
  orientation: ReportDocument['orientation']
  header: string
  pageWord: string
}): string {
  const box = 'font: 9pt sans-serif; color: #555;'
  return [
    '@page {',
    `  size: A4 ${orientation};`,
    '  margin: 18mm 15mm 20mm;',
    `  @top-left { content: ${cssString(header)}; ${box} }`,
    `  @bottom-right { content: ${cssString(`${pageWord} `)} counter(page) " / " counter(pages); ${box} }`,
    '}',
  ].join('\n')
}
